// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__yd1Z+","modalContent":"Modal_modalContent__C1wjd","closeBtn":"Modal_closeBtn__iUNeF"};